import React, { useCallback, useMemo } from "react";
import NavigationCard from "./NavigationCard";
import WelcomeBanner from "./WelcomeBanner";
import classes from "./Homepage.module.scss";
import PickUpFromLastScreen from "./PickUpFromLastScreen";
import cardData from "./NavigationCard/NavigationCardData";
import EditLayoutPanelContent from "./SidePanel/EditLayoutPanelContent";
import { useSidePanel } from "contexts/SidePanel";

const HomePageView = () => {
  const { openPanel, isOpen } = useSidePanel();
  const NavigationCardList = useMemo(() => cardData(), [isOpen]);

  const handleOpen = useCallback(() => {
    openPanel(
      <EditLayoutPanelContent />,
      {
        width: '50%',          
        position: 'right',    
        backdropClosable: false,  
        ariaLabel: 'Edit Layout panel',
        panelClassName: 'panel--edit-panel',
      }
    );
  }, [openPanel]);

  return (
      <div
        className={`homepage-wrapper ${classes["homepage-wrapper-cont"]}`}
      >
        <WelcomeBanner classes={classes} />
        <PickUpFromLastScreen classes={classes} />
        <div className={classes["explore-insight-head"]}>
          <span className={classes["explore-insight-text"]}>
            Explore your Insights
          </span>
          <button className={classes["edit-layout-btn"]} onClick={handleOpen}>
            <span className={classes["icon"]}></span>Edit Layout
          </button>
        </div>
        <section className={classes["homepage-card-list"]}>
          {NavigationCardList?.length > 0 && NavigationCardList.map((item) => (
            <NavigationCard cardItem={item} key={item.id} classes={classes} />
          ))}
        </section>
      </div>
  );
};
export default HomePageView;
